import { connect } from 'react-redux'

import {
  getPitchSummary,
  setStatusPitchSummary,
} from 'reduxpath/ducks/Project/Detail'

import TabPitchSummary from './units'

const mapStateToProps = state => ({
  projectDetail: state.ProjectDetail.data,
  pitchSummary: state.ProjectDetail.pitchSummary.data,
  filterStatus: state.ProjectDetail.pitchSummary.filterStatus,
  optionStatus: state.ProjectDetail.pitchSummary.optionStatus,
})

const mapDispatchToProps = dispatch => ({
  getDataPitchSummary(status, projectId) {
    return (event) => {
      const selectedStatus = event.target.value ? parseInt(event.target.value, 10) : ''
      if (status !== selectedStatus) {
        const qs = {
          where: {
            order: projectId,
          },
        }
        if (selectedStatus) {
          qs.where.status = selectedStatus
        }
        dispatch(setStatusPitchSummary(selectedStatus))
        dispatch(getPitchSummary(qs))
      }
    }
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(TabPitchSummary)
